import { useFileOrganizer } from "@via/hooks/useFileOrganizer.tsx";
import { type IImportedFile } from "@via/pages/data/file-organizer/file-organizer.tsx";
import PairedList from "@via/pages/data/file-organizer/file-patterns/paired-list.tsx";
import SingleList from "@via/pages/data/file-organizer/file-patterns/single-list.tsx";
import TripleList from "@via/pages/data/file-organizer/file-patterns/triple-list.tsx";
import type { SelectOption } from "@via/utils/interfaces.tsx";
import { type JSX, useEffect } from "react";
import { DataSourceProvider } from "common";

const CollectionComponents = {
  single: SingleList,
  pair: PairedList,
  triple: TripleList,
};

export default function FilePatterns({
  fileList,
  collectionType,
  globalBucketName,
  toBeRemovedFileIds,
  provider,
}: {
  fileList: IImportedFile[];
  collectionType: SelectOption;
  globalBucketName: string;
  toBeRemovedFileIds: string[];
  provider: DataSourceProvider;
}): JSX.Element | null {
  const { resetSampleList } = useFileOrganizer();

  useEffect(() => {
    resetSampleList();
  }, [collectionType]);

  const selectedTypeValue = collectionType?.value as string;

  if (!CollectionComponents[selectedTypeValue]) {
    return null;
  }

  const SelectedListComponent = CollectionComponents[selectedTypeValue];

  return (
    <div>
      <SelectedListComponent
        fileList={fileList}
        globalBucketName={globalBucketName}
        toBeRemovedFileIds={toBeRemovedFileIds}
        provider={provider}
      />
    </div>
  );
}
